import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../../utils/axios"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {
  bookOpenIcon,
  eyeCloseIcon,
  eyeOpenIcon,
} from "../../../constants/icons"
import { useToken } from "../../../context/TokenContext"
import "./AdminLogin.css"

function AdminLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { token, setToken: setMemoryToken } = useToken()

  // useEffect(() => {
  // if (token) navigate("/admin/dashboard");
  // }, [token, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const response = await axios.post("/api/admin-login", { email, password })
      if (response.data.success) {
        const { accessToken } = response.data
        setMemoryToken(accessToken)
        localStorage.setItem("accessToken", accessToken)
        toast.success(response.data.message || "Login successful!")
        navigate("/admin/subjects")
      } else {
        toast.error(response.data.message || "Invalid admin credentials")
      }
    } catch (error) {
      console.error("Login error:", error)
      toast.error(error.response?.data?.message || "Something went wrong")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='admin-login-wrapper'>
      <div className='admin-login-card'>
        <div className='admin-login-logo'>
          <div className='admin-login-icon'>{bookOpenIcon}</div>
          <h2 className='admin-login-brand'>Examally Admin Login</h2>
        </div>

        <h3 className='admin-login-title'>Login to your account</h3>

        <form className='admin-login-form' onSubmit={handleSubmit}>
          <label className='admin-login-label'>Email address</label>
          <input
            type='email'
            placeholder='admin@example.com'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='admin-login-input'
            required
          />

          <label className='admin-login-label'>Password</label>
          <div className='admin-login-password-wrapper'>
            <input
              type={showPassword ? "text" : "password"}
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className='admin-login-input'
              required
            />
            <span
              className='admin-login-eye-icon'
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? eyeOpenIcon : eyeCloseIcon}
            </span>
          </div>

          <button
            type='submit'
            className='admin-login-button'
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <ToastContainer position='top-right' autoClose={3000} />
    </div>
  )
}

export default AdminLogin
